<template>
<Modal 
    :id="'cmp-licence-licence-accounts-licence-form'"
    @cancelled="onCancelClick"  
>
    <template slot="header">
      {{year}} - {{ period_txt }}
    </template>
    <template slot="body">
      <!-- :style="{'max-height':`${tableHeight}px`,'min-height':`${tableHeight}px`}" -->
      <div >   

            <template  >
              <div v-for="(item,index) in groupedByList" class="ut-fh" :key="item.composite_key">
              <!-- <h4
                style="
                  font-weight: bold;
                  padding: 7px;
                  margin-top: 30px;
                  font-size: 14px;
                "
              >
                {{ item.title }}
              </h4> -->
                <LicenceLineTable @duplicate="onDuplicate" :tableIndex="index" @change="onValueChange" :showHeaderFlag="true" :listItem="{ items:item }" />
                <!-- <LicenceLineTable v-else :showHeaderFlag="false" :listItem="{ items:item }" /> -->
              </div>
            </template>

          <!-- <div class="ut-flex" style="margin-top:-20px">
            <div style="flex:.85">

            </div>
            <div class="ut-flex" style="flex:.2">

              <div>Invoice Amount gross : {{grossInvoiceAmounts}}</div>
              
            </div>
          </div> -->
      </div>
                      <!-- <button
                class="dt-button dt-button v5 s8"
                @click="onRefresh"
              >
                Refresh
              </button> -->        
    
     </template>
    <template slot="options">
      
        <button class="dt-button s7" @click="onCancelClick">Cancel</button>
        <button class="dt-button s7 v1" @click="onOKClicked">OK</button>
    </template>
</Modal>
  
  
</template>

<script>
import Modal from '../../../../dt-plugins/modal/modal';
import { LicenceStoreNamespace as storeNS } from "../../store";

import { DTIconButton } from "../../../../plugins/button/button";
import NTable from "../../../../plugins/datatable/datatable";

import InputField from "@plugins/text-field/input-field";

import { createNTableConfig } from '../../../../plugins/datatable';

import { createTableHeader } from "../../../../plugins/datatable";
import ModalContainer from "@dtplugins/modal/modal-container";

import { closeModalRoute  } from "../../../../dt-plugins/modal/modal.mixin";






import {
  createTV,
 
} from "../../../../models/text-value.model";

import {
  mapGetterObject,
  mapActionObject,
} from "../../../../store/global";


import { MHTTPCL } from '../../../../services/http/http-client';
import { licenceAccountsGetters } from '../../store/accounts/getters';
import { licenceAccountsActions } from '../../store/accounts/actions';
import { licenceAccountsService } from '../../services/licence-accounts.service';

import LicenceLineTable from './licence-line-table-modal.vue';
import { NotificationService } from '../../../../dt-plugins/notification/notification.service';
import { invoiceListLDTRoutes } from '../../../accounting/router/routes';


export default {
  props: {
    requestPayload: {
      type: Object
    }
  },
  components: {
    
    Modal,
    NTable,
    InputField,
    DTIconButton,
    LicenceLineTable,
    ModalContainer,
   
    //AdvanceSearch,
   
  },
  mounted:async  function () {
      const resData= await licenceAccountsService.addLicenceIncomeModal2Data({ ...this.requestPayload });
      this.licenceList=resData.data.licence_lines
      console.log(this.requestPayload,"this.$route",resData)

      const chapterKeyDict = Object.groupBy(this.licenceList, ({ chapter_key }) => chapter_key);

      // const externalKeyDict = Object.values(chapterKeyDict).map(x=>{
      //   return Object.groupBy(x, ({ external_table }) => external_table)
       
      // }).map(x=>{
      //   return Object.values(x)
      // })

      // console.log("this.$externalKeyDict",externalKeyDict)
      this.groupedByList = Object.values(chapterKeyDict).map(x=>{
        return x.map((y,index)=>{
          return{
            ...y,
            qty_info:'',
            statement_amount:'',
            reserve_amount:'',
            balance_amount:'',
            invoice_amount:'',
            sales_info:'',
            text:this.requestPayload.text,
            licence_line_date:this.requestPayload.date,
            licence_line_year:this.requestPayload.year,
            licence_line_period_txt:this.requestPayload.period,
            currency_id:this.requestPayload.currency_id,
            composite_key:`${y.chapter_key}${y.external_id}${y.licence_track_id}${index}`


          }  
        })
      })

      this.groupedByList = this.groupedByList.map(i=>{
        return i.sort((x,y)=>{
          const a = x.external_table.toUpperCase(); 
          const b = y.external_table.toUpperCase(); 
          if (a < b) {
            return -1;
          }
          if (b > a) {
            return 1;
          }

          return 0;
        });
      })

      const externalKeyList1 = this.list


      console.log(this.groupedByList,"this.$route",chapterKeyDict)
  },
  data: function () {
    return {
      licenceList:[],
      groupedByList:[],
      sales_infos:'',
      statement_amounts:'',
      reserve_amounts:'',
      balance_amounts:'',
      invoice_amounts:'',
      licence_ids:''
    
    };
  },
   mixins: [
    
    // createLDTHost(LDTConfig),
    
    //createModalMixin("advanceSearch"),
    // createAdvancedSearchHost(releaseListAdvancedSearchConfig, {
    //   onBeforeAdvancedSearchFetch:
    //     "onBeforeAdvancedSearchFetch",
    // }),
    
  ],

  computed: {
    // ...mapGetters(storeNS, {
    //   releasesCatalogData: "releasesCatalogData",
  
     
    // }),
    ...mapGetterObject(storeNS,licenceAccountsGetters),
    tableHeight:function(){
    
      return 60*(this.licenceList.length+1)+30;

    },
    grossInvoiceAmounts:function(){
      const amt = this.licenceList.reduce((accum=0,cur)=>{
        return accum+=parseFloat(cur['invoice_amount_input'])

      },0);

      return amt.toFixed(2)
    },
    date:function(){
      return this.$route.query.date
    },  
    text:function(){
      return this.$route.query.text
    },  
    year:function(){
      return this.$route.query.year
    },  
    period_txt:function(){
      return this.$route.query.period
    },  
    licence_account_id:function(){
      return this.$route.query.licence_account_id
    },  
    currency_id:function(){
      return this.$route.query.currency_id
    },
    invoice_project_id:function(){

      return this.$route.query.invoice_project_id

    },

    tableConfig: function () {
      return createNTableConfig({
        fullHeight: true,
        headerStyle: 3,
        rowHeight: 60,
      });
    },

    
  },
  methods: { 
   ...mapActionObject(storeNS, licenceAccountsActions),
   
   closeModal:function(){
       closeModalRoute(this);
    },
    onRefresh:function(){

    },
    onCheckBoxChange:function(e,item){
      console.log(e.target.checked);
    },
    onValueChange:function(payload){
      
      const { name ,value ,composite_key,tableIndex} =payload;
      
      console.log(payload,",,,",this.groupedByList[tableIndex])

      this.groupedByList=this.groupedByList.map((item,index)=>{
        if(index==tableIndex){
          return item.map(x=>{
          
            if(x.composite_key==composite_key){
              if(name=='invoice_amount'){
                return{
                  ...x,
                  //statement_amount:value,
                  invoice_amount:value
                }
              }else{
                console.log(name,"XX",{...x,[name]:value})
                return{
                  ...x,
                  [name]:value
                }
              }
            }else{
              return { ...x}
            }
          })
        }else{
          return item;
        }
        
      });
      // console.log(this.groupedByList,"::::::::::::::::::::",this.groupedByList.reduce((accum,cur)=>{
      //   return accum = [...cur,...accum]
      // },[]).map(x=>{
      //   return {
      //     invoice_amount:x.invoice_amount
      //   }
      // }))


    },

    onDuplicate:function(payload){
      const { item,tableIndex ,index} =payload;
      this.groupedByList=this.groupedByList.map((x,i)=>{
        if(i==tableIndex){
          return [  ...x.slice(0, index),item,...x.slice(index)].map((y,o)=>{
            return {
              ...y,
              composite_key:`${y.chapter_key}${y.external_id}${y.licence_track_id}${o}`


            }
          })
        }else{

          return x;
        }
        
      });
    },




    onOKClicked:async function(){
      

     

      const listPayload =this.groupedByList.reduce((accum,cur)=>{
        return accum = [...cur,...accum]
      },[]).map(x=>{
        return{
          sequence_no_for_licence_lines:x.sequence_no_for_licence_lines,
          asset_type:x.asset_type,
          identifier:x.identifier,
          artist:x.artist,
          title:x.title,
          currency_id:x.currency_id,
          licence_id:x.licence_id,
          licence_track_id:x.licence_track_id,
          external_id:x.external_id,
          external_table:x.external_table,
          text:x.text,
          licence_line_year:x.licence_line_year,
          licence_line_period_txt:x.licence_line_period_txt,
          sales_info:x.sales_info,
          qty_info:parseFloat(x.qty_info)==0?'':x.qty_info,
          statement_amount:x.statement_amount,
          reserve_amount:x.reserve_amount,
          balance_amount:x.balance_amount,
          invoice_amount:x.invoice_amount


        }
      })
      console.log(this.licence_account_id,"ARRAY",[...listPayload],{licence_account_id:this.licence_account_id,licence_id:'',licence_lines:listPayload})
      const resInvoice =await licenceAccountsService.addLicenceIncome({date:this.date,text:this.text,invoice_project_id:this.invoice_project_id,year:this.year,currency_id:this.currency_id,period:this.period_txt, licence_account_id:this.licence_account_id,licence_id:'',licence_lines:listPayload});
      console.log('resInvoice',resInvoice)
      if(resInvoice.data.invoice_id=='')
      {
        NotificationService.showNotification({
          text: "Invoice creation condition failed",
          timeout: 5000,
        });

      }else{
        this.$router.push({
          name: invoiceListLDTRoutes.names.tab,
          params: {
            invoice_id: resInvoice.data.invoice_id,
            tab: "overview",
          },
        });
      }
      this.$emit("cancelled", true);
    },
    onCancelClick: function() {
      this.$emit("cancelled", true);
    },

  
  },
};
</script>

<style lang="scss">
.cmp-licence-licence-accounts-licence-form {
  .text-field-border{
    border:1px solid var(--sprt-12)
  }
}
</style>